<template>
  <div>
    <br>
<!-- <DxList
          id="list"
          :data-source="dataSource"
          @item-click="showActionSheet"
          :search-enabled="true"
          search-mode="startswith"
          class="p-2"
        > -->

        <DxList
          id="list"
          :data-source="dataSource"
          :search-enabled="true"
          search-mode="startswith"
          class="p-2 list-container"
          page-load-mode="scrollBottom"
        >
        
      <template #item="{ data }" style="padding:4px;">
       <span>
          <span class="grid grid-cols-2 gap-4">
            <!-- columns[0].dataField -->
            <span v-if="!!data.name" class="text-lg font-weight-bold">{{data.name}}</span>  
            <span v-else class="text-lg font-weight-bold">{{data.description}}</span>        

            <div class="text-right">
              <i class="fas fa-eye p-2 rounded bg-green-500" v-on:click="moveToDetailsScreen(data.id)"></i>
              
              <i v-if="routeDef === 'users'" class=""></i>
              <i v-else-if="routeDef === 'audits'" class=""></i>
              <i v-else class="fas fa-edit p-2 ml-1 rounded bg-red-500" v-on:click="moveToEditScreen(data.id)"></i>
            </div>
          </span>
          <details class="mt-1">
            <MobileListItem :item-data="data" :module-route="routeDef" :columns="columns" />
          </details>
       </span>
       </template>

    </DxList>

    <br>

    <DxActionSheet
      :items="actionSheetItems"
      v-model:visible="isActionSheetVisible"
      v-model:target="actionSheetTarget"
      :use-popover="true"
      title="Choose action"
      @itemClick="showClickNotification($event.itemData.text,clickedItem)"
    />

  </div>
</template>

<script>
import CustomStore from "devextreme/data/custom_store";
import DxList from 'devextreme-vue/list';
import MobileListItem from './MobileListItem.vue';
import DxActionSheet from 'devextreme-vue/action-sheet';
import { actionSheetItems } from './listviewdata/data.js';
import DxSelectBox from 'devextreme-vue/select-box';



let mRoute;

function setRoute(context) {
  console.log("outside vue");
  mRoute = context.routeDef;
}

function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}

const store = new CustomStore({
    key: 'id',
    paginate: true,
    pageSize: 1,
    load: function (loadOptions) {
    var parameters = {};
  

    if (loadOptions.sort) {
      parameters.order_column = loadOptions.sort[0].selector;
      if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
    }
    //console.log(loadOptions);
    parameters.filter = JSON.stringify(loadOptions.filter);
    parameters.skip = loadOptions.skip;
    parameters.take = loadOptions.take;

    parameters.page = (parameters.skip + parameters.take) / parameters.take;
    var config = {
      params: parameters,
    };

    //let listurl = "/" + "tenants" + "/list";
    console.log("Inside Store::"+mRoute);

    let listurl = "/" + mRoute + "/list";
    let createurl = "/" + mRoute + "/create";

    return axios
      .get(listurl, config)
      .then((response) => {
        console.log(response.data.results.data)
        return {
          data: response.data.results.data, 
          totalCount: response.data.results.total,
        };
      })
      .catch(() => {
        throw "Data Loading Error";
      });
  }
});


export default {
   props: {
    routeDef: String,
    headersDef: Array,
  },
    components: {
        DxList,
        MobileListItem,
        DxActionSheet,
        DxSelectBox,

    },
    methods: {
      moveToEditScreen(itemId){
        console.log("clickedItem:"+itemId);
        this.$inertia.get(this.routeDef+"/"+itemId+"/edit");
      }
      ,moveToDetailsScreen(itemId){
        console.log("clickedItem:"+itemId);
        this.$inertia.get(this.routeDef+"/"+itemId);
      }
      ,
      showActionSheet(e) {
      this.actionSheetTarget = e.itemElement;
      this.clickedItem=e.itemElement;
      // console.log("CLICKEDITEM::",e.itemElement);
      // console.log("CLICKEDITEM::",e.itemElement.getElementsByTagName("span"));
      this.isActionSheetVisible = true;
    },
    showClickNotification(buttonName,clickedItem) {
      var elementId=clickedItem.getElementsByTagName("span").rowId.innerHTML;
      // console.log("ELEMENT_ID::"+elementId);
      
      if (buttonName==='Edit'){
        // alert("EDIT");
        this.$inertia.get(this.routeDef+"/"+elementId+"/edit");
      }

      else if (buttonName==='Delete'){
        // alert("Delete");
      }

      else if (buttonName==='Detail'){
        this.$inertia.get(this.routeDef+"/"+elementId);
      }

      else if (buttonName==='Call'){
        // alert("Call");
      }
    },
    setColumnDefs() {
      var columnDefs1 = [
        // {
        //   dataField: "Actions",
        //   allowFiltering: false,
        //   allowSorting: false,
        //   width: 60,
        //    cellTemplate: function (cellElement, cellInfo) {
        //         cellElement.append('View');
        //     }
        // }
      ];
      let result = this.headersDef;
     
      let reformattedArray = result.map((obj) => {
        let rObj = {};
        rObj["dataField"] = obj.name;
        rObj["caption"] = obj.label;
        return rObj;
      });

      columnDefs1 = columnDefs1.concat(reformattedArray);

      return columnDefs1;
    },
    startEdit(e,i) {
      if (e.columnIndex == 0) {
       // alert(e.data.name);
       // window.location.href = this.routeDef+"/"+e.data.id;
        
        this.$inertia.get(this.routeDef+"/"+e.data.id);

      }
    },
    onCellPrepared(e) {
      if (e.columnIndex == 0 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        elem.style.setProperty("color", "blue");
      }
    },
    onCellHoverChanged(e) {
      if (e.columnIndex == 0 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        if (e.eventType === "mouseover") {
          e.cellElement.style.color = "blue";
        } else {
          e.cellElement.style.color = "";
        }

        elem.style.setProperty("color", "green");
      }
    },
    setRoute(context) {
     mRoute = context.routeDef;
},
  },
    created() {
        setRoute(this);
  },
      data() {
        return {
          dataSource: store,
          actionSheetItems,
          isActionSheetVisible: false,
          actionSheetTarget: '',
          clickedItem: '',
          searchMode: 'contains',
          columns: this.setColumnDefs(),
        };
  },

}

</script>

<style>

details {
  list-style-type: none;
  text-align:right;
}

summary {
  list-style: none;
  display: block;
}
details::-webkit-details-marker {
  display: none;
}



</style>